export default __webpack_public_path__ + "static/media/logotipo.fcd15580.png";